/**
 * The Chat members dialog's `Invite people` search result state, pure
 * TypeScript. No React, no DOM, no SDK: given a candidate the search
 * matched, whether the chat already has them as a member, and who has
 * already been invited this session, what does that search result row show
 * (ISSUE-283, the half ISSUE-760's fan search left for this card, per
 * `standaloneChatCopy.ts`'s `CHAT_INVITE_SEARCH_ACTION_LABEL` and its
 * neighbours).
 */

export type typeInviteRowState = "invite" | "sent" | "alreadyMember";

export function resolveInviteRowState({
  candidateUserId,
  existingMemberUserIds,
  sentUserIds,
}: {
  candidateUserId: string;
  existingMemberUserIds: ReadonlySet<string>;
  sentUserIds: ReadonlySet<string>;
}): typeInviteRowState {
  if (existingMemberUserIds.has(candidateUserId)) {
    return "alreadyMember";
  }
  if (sentUserIds.has(candidateUserId)) {
    return "sent";
  }
  return "invite";
}
